// convex/lib/config/validator.ts
// Generates modulesTypes validator from MODULES
// This breaks the circular dependency by not importing from domains

import { v } from "convex/values";
import { MODULES, type ModuleId } from "./modules";

/**
 * Validator de Convex generado desde MODULES
 * Incluye todos los modulos definidos en el sistema
 */
export const modulesTypes = v.union(...MODULES.map((id) => v.literal(id)));

/**
 * Tipo TypeScript derivado del validator
 */
export type ModuleType = ModuleId;

/**
 * Helper para verificar si un string es un modulo valido
 */
export function isValidModule(value: string): value is ModuleType {
  return (MODULES as readonly string[]).includes(value);
}

/**
 * Array constante de todos los modulos
 * Util para iteraciones y validaciones
 */
export const ALL_MODULES = MODULES;

/**
 * Validador para acciones sobre modulos
 */
export const actions = v.union(
  v.literal("read"),
  v.literal("create"),
  v.literal("update"),
  v.literal("delete"),
);

/**
 * Tipo TypeScript para acciones
 */
export type ActionType = "read" | "create" | "update" | "delete";
